// extracted by mini-css-extract-plugin
export default {"main":"Alternance_main__XccYU","container":"Alternance_container__sQcDO","container2":"Alternance_container2__JMOB4","body":"Alternance_body__PDEvK","page":"Alternance_page__VWu6j"};